/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import langDe from '../i18n/de/resource.json'
import langEn from '../i18n/en/resource.json'
import {DEFAULT_LANGUAGE} from 'helpers/config'
import store from 'helpers/store'

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: langEn,
    },
    de: {
        translation: langDe,
    },
}

const state = store.getState()
const langFromRedux = state.sessionState?.language?.code
const langFromProfile = state.sessionState?.profile?.lang
const lang = langFromRedux || langFromProfile || DEFAULT_LANGUAGE
i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        returnEmptyString: false,
        fallbackLng: false,
        lng: lang,
        debug: false,
        nsSeparator: false,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        //formatFallbackMessages: true
    })

export default i18n
